import BrandLogo from "../../atoms/brandLogo";
import { numberFormat } from "../../../utils";
// import { API_URL } from "../../constants";
// import axios from "axios";
import wave from "../../../assets/images/waves pattern.svg";
import {
  Container,
  HeaderImage,
  Heading,
  Card,
  SubDiv,
  Note,
  Total,
  Checkout,
} from "./styles";
import { useState } from "react";

function Invoice({
  setStep1,
  profile,
  checkoutData,
  setIsInvoiceOpened,
  hero,
}: any) {
  const [isloading, setisloading] = useState(false);


  //form handler
  const submitHandler = (data: any) => {
    setisloading(true);
    setStep1(true);
    setIsInvoiceOpened(false);
  };

  const submitValue: any = isloading ? (
    <div className="flex justify-center  text-[#ffffff] ...">
      <svg
        className="animate-spin  h-5 w-5  ..."
        viewBox="0 0 20 20"
        version="1.1"
        fill="#000000"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <title>ic_fluent_spinner_ios_20_regular</title>{" "}
          <desc>Created with Sketch.</desc>{" "}
          <g
            id="🔍-System-Icons"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            {" "}
            <g
              id="ic_fluent_spinner_ios_20_regular"
              fill="#ffffff"
              fillRule="nonzero"
            >
              {" "}
              <path
                d="M10,3 C6.13401,3 3,6.13401 3,10 C3,10.2761 2.77614,10.5 2.5,10.5 C2.22386,10.5 2,10.2761 2,10 C2,5.58172 5.58172,2 10,2 C14.4183,2 18,5.58172 18,10 C18,14.4183 14.4183,18 10,18 C9.72386,18 9.5,17.7761 9.5,17.5 C9.5,17.2239 9.72386,17 10,17 C13.866,17 17,13.866 17,10 C17,6.13401 13.866,3 10,3 Z"
                id="🎨-Color"
              >
                {" "}
              </path>{" "}
            </g>{" "}
          </g>{" "}
        </g>
      </svg>
      <span className="ml-2">Processing...</span>
    </div>
  ) : (
    "Checkout"
  );

  return (
    <Container className="bg-#FFF] px-[5%]  ">
      <HeaderImage>
        <img src={hero ? hero.headerImage : wave} alt="" />
      </HeaderImage>
      <Heading>
        <BrandLogo src={profile?.image} />
      </Heading>
      <Card>
        <h1>Invoice</h1>

        <SubDiv>
          <h2>Subtotal Bill</h2>
          <p>{numberFormat(checkoutData.amount)}</p>
        </SubDiv>
        <SubDiv>
          <h2>From</h2>
          <p className="text-[0.875em]">{checkoutData.phoneNumber}</p>
        </SubDiv>
        <Note>
          <h2>Note</h2>
          <p>{checkoutData.note}</p>
        </Note>

        <Total>
          <h2>Total</h2>
          <h2>{numberFormat(checkoutData.amount)}</h2>
        </Total>

        <Checkout type="submit" onClick={submitHandler}>
          {submitValue}
        </Checkout>
      </Card>
    </Container>
  );
}

export default Invoice;